require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./setting-auto-generated-ids-manually-in-hibernate.json") })
        }
      }, "path---setting-auto-generated-ids-manually-in-hibernate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---setting-auto-generated-ids-manually-in-hibernate!./.cache/json/setting-auto-generated-ids-manually-in-hibernate.json
// module id = 336
// module chunks = 231608221292675